export function isPluginMode() {
  const urlParams = window.location.hash.split('/');
  const firstItem = urlParams.length > 1 ? urlParams[1] : '';

  return firstItem.includes('variable-rate');
}